import { GamePlayData, LocationEnum, SessionInputs, WaveResult } from '../types'
import { generateSessionInputs } from './generateSessionInputs'
import { generateWaveInputs } from './generateWaveInputs'
import { generatePlayerWaveResult } from './generatePlayerWaveResult'
import { SURF_MINUTES_PER_ENERGY } from '@/constants/game'

export function getSessionLength(gameData: GamePlayData): number {
  return gameData.currencies.energy.amount * SURF_MINUTES_PER_ENERGY
}

export function generateSurfSession(
  locationKey: LocationEnum,
  gameData: GamePlayData,
  sessionLength: number
): { sessionInputs: SessionInputs; waveResults: WaveResult[] } {
  const isWhiteWater = !gameData.isSurfingGreenWave
  const sessionInputs = generateSessionInputs(locationKey, gameData.skills, isWhiteWater)

  let remainingTime = sessionLength

  const waveResults: WaveResult[] = []

  while (remainingTime > 0) {
    const waveInputs = generateWaveInputs(locationKey, sessionInputs, gameData.skills, isWhiteWater)
    if (remainingTime < waveInputs.waitingForWaveTime) break
    const waveResult = generatePlayerWaveResult(gameData, sessionInputs, waveInputs)
    waveResults.push(waveResult)

    // Check for medium or high severity hazards
    const severeHazard = waveResult.hazards.some((hazard) => hazard.severity === 'medium' || hazard.severity === 'big')

    if (severeHazard) {
      break // End session early due to significant hazard
    }

    remainingTime -= waveInputs.waitingForWaveTime
  }
  return { sessionInputs, waveResults }
}
